@use 'ui/styles/core-tokens' as core;

.overlay {
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 52;
}
